// https://stackoverflow.com/a/175787
export function isStringNumeric(value: string)
{
    return !isNaN(value as any) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
        !isNaN(parseFloat(value)); // ...and ensure strings of whitespace fail
}
